/**
 * TAXII 2.1 / STIX 2.1 export helpers.
 *
 * Downloads the indicator bundle as a JSON file.
 * Passes the JWT via Authorization header (not query param)
 * so the file download is initiated programmatically.
 */

export async function downloadStixBundle(addedAfter?: string): Promise<void> {
  const token = localStorage.getItem('token');
  const params = new URLSearchParams({ limit: '1000' });
  if (addedAfter) params.set('added_after', addedAfter);

  const res = await fetch(`/api/v1/taxii/collections/indicators/objects/?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) throw new Error(`TAXII export failed: ${res.status}`);

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `iocs-stix21-${new Date().toISOString().slice(0, 10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
}

export async function getTaxiiManifest(limit = 100): Promise<any> {
  const token = localStorage.getItem('token');
  const res = await fetch(`/api/v1/taxii/collections/indicators/manifest/?limit=${limit}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`TAXII manifest failed: ${res.status}`);
  return res.json();
}
